import { Text } from '@rsos/base-components';
import { formatInternationalPhoneNumberHuman } from '@rsos/utils/internationalPhoneNumberUtils';

const ToastMessage = ({
  selectedCallerID,
  resourceLabel,
}: {
  selectedCallerID: null | string;
  /**
   * Set for alert and resource request shares, which have no phone number to
   * format.
   */
  resourceLabel?: string | null;
}) => {
  const subject =
    resourceLabel ??
    (selectedCallerID
      ? formatInternationalPhoneNumberHuman(selectedCallerID)
      : null);

  if (!subject) return null;

  return (
    <Text>
      Event details from{' '}
      <Text fontWeight="bold" inline>
        {subject}
      </Text>{' '}
      were shared to field responders.
    </Text>
  );
};

export default ToastMessage;
